import React from 'react';

import TalkBase from '../_talk';
import talk from './chrome-devtools.json';

export default () => <TalkBase talk={talk} />;



// WEBPACK FOOTER //
// ./pages/talks/chrome-devtools/index.js